module.exports = global["animateNumber"] = require("-!C:\\Users\\User\\Dropbox\\Frontend\\колым\\streamwood\\streamwood-site\\node_modules\\babel-loader\\lib\\index.js!.\\jquery.animateNumber.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?animateNumber!./vendor/animateNumber/jquery.animateNumber.js
// module id = 36
// module chunks = 0